import axios from 'axios'
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
export const GET_PRODUCTS = 'GET_PRODUCTS'
export const ADDTOCARD_LIST = 'ADDTOCARD_LIST'
export const GET_LISTOFORDER = 'GET_LISTOFORDER'
export const GET_PRODUCTS_FORDECORE = 'GET_PRODUCTS_FORDECORE'
export const ADMIN_LOGIN = 'ADMIN_LOGIN'
export const GET_GROCERY_PRODUCTS = 'GET_GROCERY_PRODUCTS'
export const ADDTOCARD_GROCERY_LIST = 'ADDTOCARD_GROCERY_LIST'
export const GET_ACCESSKEYS = 'GET_ACCESSKEYS'

export const getProducts = (navItem, setMenuItems) => {
    return async (dispatch) => {

        // 1. Tell the component we are loading
        // dispatch({ type: 'GET_PRODUCTS_LOADING' });
    
        try {
          const res = await axios.get(
            "https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/products"
          );
    
          const TrendingProducts = res.data;
          setMenuItems(TrendingProducts);
        //   console.log(TrendingProducts)
          const productaction = TrendingProducts && TrendingProducts.products && TrendingProducts.products.find(
            (val) => val.product_for === navItem
          );
    
          // 2. If no match found for navItem — dispatch empty not undefined
          dispatch({
            type: 'GET_PRODUCTS',
            payload: productaction || null,
          });
    
        } catch (err) {
          console.error("getProducts error:", err);
          // 3. Tell the component something went wrong
          dispatch({ type: 'GET_PRODUCTS_ERROR', payload: err.message });
        }
      };
};

export const getGroceryProducts = (navItem) => {
    return async (dispatch, getState) => {
        dispatch({ type: 'GET_PRODUCTS_LOADING' });
        try{
        let TrendingProducts = await axios.get("https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/organic_products")
            .then(r => r)
            .then(res => res.data)
            .catch(err => console.log(err))

        let productaction = TrendingProducts && TrendingProducts.products && TrendingProducts.products.find((val, i) => {
            return val.product_for == navItem
        })
        dispatch({
            type: 'GET_GROCERY_PRODUCTS',
            payload: productaction
        });
    } catch (err) {
        // 3. Tell the component something went wrong
        dispatch({ type: 'GET_GROCERY_PRODUCTS', payload: err.message });
      }
    }
};

export const getProductsforDecore = (item) => {
    return async (dispatch, getState) => {
        dispatch({ type: 'GET_PRODUCTS_LOADING' });
        try{
        let TrendingProducts = await axios.get("https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/products")
            .then(r => r)
            .then(res => res.data)
            .catch(err => console.log(err))

        let productaction = TrendingProducts && TrendingProducts.products && TrendingProducts.products.find((val, i) => {
            return val.product_for == item
        })
        dispatch({
            type: 'GET_PRODUCTS_FORDECORE',
            payload: productaction
        });
    } catch(err){
        dispatch({ type: 'GET_PRODUCTS_FORDECORE', payload: err.message });
    }
    }
};

export const AddtocardList = (orderedList) => {
    return async (dispatch) => {
        dispatch({
            type: 'ADDTOCARD_LIST',
            payload: orderedList
        });
    }
}

export const AddtoGROCERYList = (orderedList) => {
    return async (dispatch) => {
        dispatch({
            type: 'ADDTOCARD_GROCERY_LIST',
            payload: orderedList
        });
    }
}

export const oncheckout = (type) => {
    // console.log(type)
    return async (dispatch, getState) => {
        let TrendingProducts = await axios.get("https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/ccavResponseHandler")
            .then(r => r)
            .then(res => {
                // console.log(res)
                const data = res && res.data && res.data.products && res.data.products.filter((val, i) => {
                    // return val.section.map((val, i) => val.type) == type
                    return val.payment_success === type
                })
           
                return data
            })
            .catch(err => console.log(err))
        // console.log(TrendingProducts)
        // let productaction = TrendingProducts && TrendingProducts.products && TrendingProducts.products.filter((val, i) => {
        //     return val.product_id == 1
        // })
// console.log(TrendingProducts)
        dispatch({
            type: 'GET_LISTOFORDER',
            payload: TrendingProducts
        });
    }
}

export const OnLogin = (data) => {
    const navigate = useNavigate()
    return async (dispatch) => {
        if (data.email == "triokzz0@gmail.com" && data.password == "triokzz9800") {
            navigate('/checkout', { state: data })
        }
    }
}


export const accessApiKey = () => {
    return async (dispatch, getState) => {
        let access = await axios.get("https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/mykeyvalueapi")
            .then(r => r)
            .then(res => res.data)
            .catch(err => console.log(err))
        dispatch({
            type: 'GET_ACCESSKEYS',
            payload: access
        });
    }
}

export const SignUpUser = (data, props, state, navigate) => {
    // console.log(props)
    return async (dispatch, getState) => {

        await axios.post("https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/register", {
            "user_name": data.firstName + " " + data.lastName,
            "password": data.password ? data.password : ""
        }).then(r => {
            // console.log(r)
            if (r.data.length > 0) {
                // console.log(r.data)

                localStorage.setItem("signiniNFO", JSON.stringify(r.data[0]))
                props.close()
                toast("your strong password must be !@#$%^&* Atoz")
            }
        }).catch(e => {
            // console.log(e && e.status)
            if (e && e.status == 404) {

               axios.post("https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/register", {
                    "id": data.firstName.replace(/\s+/g, ' ').trim()+data.email.substr(0, 5)+`+91${data.phone}`,
                    "user_name": data.firstName.replace(/\s+/g, ' ').trim() +" "+ data.lastName.replace(/\s+/g, ' ').trim(),
                    "email": data.email,
                    "firstName": data.firstName.replace(/\s+/g, ' ').trim(),
                    "lastName": data.lastName.replace(/\s+/g, ' ').trim(),
                    "message": "Login successful!",
                    "address": data.address ? data.address : "none",
                    "type": data.type ? data.type : data.email,
                    "products_type": data.products_type ? data.products_type : "none",
                    "state": data.state ? data.state : "none",
                    "city": data.city ? data.city : "none",
                    "password": data.password ? data.password : "",
                    "products": data.products ? data.products : [],
                    "success": true,
                    "phone": data.phone ? `+91${data.phone}` : props.mynumber,
                    "role": state && state.role ? state.role : "user"
                }).then(r => {
                    // console.log()
                    if (r.status == 200) {
                        if (state && state.role) {
                            navigate('/login/seller')
                        } else {
                            localStorage.setItem("signiniNFO", r.config.data)
                            props.close()
                        }

                    }
                }).catch(e => {
                    console.log(e)
                    toast("Your information already exist")
                    props.close()
                    localStorage.setItem("signiniNFO", e.config.data)
                    // console.log("error:",e)
                })
            } else {
                toast("You already registered, Please check phone, user name or password")
            }
        })
    }
}

export const loginData = (data, navigate) => {
    return async (dispatch, getState) => {
        await axios.post("https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/register", {
            "user_name": data.user_name,
            "password": data.password
        }).then(r => {
            if (r.data.length > 0) {
                // console.log("signin sucessful")
                navigate("/dashboard/seller", { state: r.data })
            } else {
                alert("Please enter valid username or password")
            }
        }).catch(e => {
            console.log("error:", e)
            alert("Something went wrong, please try after some time")
        })
    }
}

export const ResetPassword= (data, navigate) => {
    return async (dispatch, getState) => {
        let access = await axios.put("https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/forgetpassword", {
            "user_name": data.user_name,
            "email":data.email,
            "password": data.password
        })
            .then(r => r)
            .then(res => {
                if(res.data){
                    navigate("/login/seller")
                }
            // console.log(res.data)
    })
            .catch(err => console.log(err))
        // dispatch({
        //     type: 'GET_ACCESSKEYS',
        //     payload: access
        // });
    }
}

export const fetchDeliveryTrackaPI = (orderId, setStatus) => {
    return async (dispatch, getState) => {
        const prod = 'https://track.delhivery.com/api/v1/packages/json/?'
        const url = `https://staging-express.delhivery.com/api/v1/packages/json/?waybill=${orderId}&ref_ids=716135`;
        const options = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', Authorization: 'Token f428c266c2cdfbd73c462cd7f56d310d04c91bbc', 'Access-Control-Allow-Origin': "*" }
        };

        fetch(url, options)
            .then(res => res.json())
            .then(json => console.log(json))
            .catch(err => console.error(err));
        // .then(json => setStatus(json.ShipmentData.map((item, i)=> item.Shipment)))
        // dispatch({
        //     type: 'GET_ACCESSKEYS',
        //     payload: access
        // });
    }
}
// export default { getProducts }